import styled from 'styled-components';

export const SocialSection = styled.div`
  text-align: center;
  cursor: pointer;
`;

export const Icons = styled.div`
  span {
    margin: 0 6px !important;
  }
`;
export const PrivacyPolicy = styled.div`
  font-size: 13px;
  padding: 10px 0;
  color: #606060;
  cursor: pointer;
`;

export const CopyRights = styled.div`
  font-size: 11px;
  color: rgb(0 0 0 / 44%);
  padding: 10px 6px 16px;
`;
